import {
   ChangeDetectionStrategy,
   Component,
   Inject,
   OnDestroy,
   OnInit,
   ViewChild,
   ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CallState } from '@lcs/shared/api';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { editPresenceCredentialsSubmit } from '../../account-details/state/account-detail.actions';
import { sipPasswordValidators } from 'src/app/common-components/validators/password.validator';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-edit-presence-credentials',
    styleUrls: ['./edit-presence-credentials.component.scss'],
    templateUrl: './edit-presence-credentials.component.html',
    standalone: false
})
export class EditPresenceCredentialsComponent implements OnInit, OnDestroy, FormComponent {
   @ViewChild(EditPresenceCredentialsComponent) editPresenceContactViewComponent: EditPresenceCredentialsComponent;

   callState: Observable<CallState>;

   form: UntypedFormGroup;

   private destroyed$ = new Subject<void>();

   private username: Observable<String>;

   enabled: Observable<Boolean>;

   constructor(
      protected store: Store,
      private fb: FormBuilder,
      private dialogService: LcsDialogService,
      public dialogRef: MatDialogRef<EditPresenceCredentialsComponent>,
      @Inject(MAT_DIALOG_DATA) private data: any
   ) {
      this.enabled = data.enabled;
   }

   ngOnInit(): void {
      this.initializeForm();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   initializeForm(): void {
      this.form = this.fb.group(
         {
            password: [null, [Validators.required, Validators.maxLength(255), ...sipPasswordValidators()]],
            confirmPassword: [null, Validators.required],
            username: [this.data.username, [Validators.required, Validators.maxLength(255)]],
         },
         { validator: this.validPassword }
      );
   }

   validPassword(control: UntypedFormGroup) {
      const password = control.get('password')?.value;
      const confirmPasswordControl = control.get('confirmPassword');

      if (!confirmPasswordControl) {
         return null;
      }
      const existingErrors = confirmPasswordControl.errors || {};

      if (password !== confirmPasswordControl.value) {
         confirmPasswordControl.setErrors({
            ...existingErrors,
            validPassword: true,
         });
      } else {
         const { validPassword, ...otherErrors } = existingErrors;
         confirmPasswordControl.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
      }

      return null;
   }

   onCloseClick(): void {
      this.dialogService.close();
   }

   onCreate(): void {
      if (this.form.valid) {
         var fields = this.getFormSubmittedEvent();
         this.store.dispatch(
            editPresenceCredentialsSubmit({
               username: this.form.value.username,
               password: this.form.value.password,
               confirmPassword: this.form.value.confirmPassword,
               fields: fields,
            })
         );
      }
      this.dialogRef.close();
   }

   private getFormSubmittedEvent(): string[] {
      const dirtyFields: string[] = [];

      Object.keys(this.form.controls).forEach((controlName) => {
         const control = this.form.get(controlName);
         if (control?.dirty) {
            if (controlName === 'username') {
               dirtyFields.push('PresenceUser');
            } else if (controlName === 'password') {
               dirtyFields.push('PresencePassword');
            }
         }
      });

      return dirtyFields;
   }
}
